module.exports = "//static.hsappstatic.net/salesImages/static-1.403/workflows/workflows-empty-fte.svg"